import { createFileRoute } from "@tanstack/react-router";
import { GuidesHub } from "./guider.index";

const TITLE = "Guides to buying and selling online | Sellavo";
const DESCRIPTION =
  "Practical guides to selling second hand online: pricing, photos, listing text, shipping and safe deals.";

export const Route = createFileRoute("/en/guides")({
  loader: async () => {
    const { GUIDES } = await import("@/lib/guides");
    return {
      guides: GUIDES.map((g) => ({
        slug: g.slug,
        title: g.title,
        description: g.description,
        readMinutes: g.readMinutes,
      })),
    };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/guides" }],
  }),
  component: GuidesHub,
});
